import React, { useContext } from 'react'
import slugify from 'react-slugify'
import Context from '../../context'

function MomentData() {
  const { formObject, setFormObject } = useContext(Context)
  const onBlurToSlug = str => {
    setFormObject({ ...formObject, slug: slugify(str) })
  }

  const handleTextArea = value => {
    setFormObject(data => {
      return { ...data, description: value }
    })
  }

  return (
    <>
      <h5>Dados do Momento</h5>
      <div className="row">
        <div className="col-md-6 col-sm-12" style={{ marginBottom: '20px' }}>
          <label htmlFor="title">Título</label>
          <input
            value={formObject.title || ''}
            onChange={e => setFormObject({ ...formObject, title: e.target.value })}
            onBlur={e => onBlurToSlug(e.target.value)}
            type="text"
            className="form-control"
            id="title"
            placeholder="Título"
          />
        </div>

        <div className="col-md-6 col-sm-12" style={{ marginBottom: '20px' }}>
          <label htmlFor="slug">Slug</label>
          <input
            value={formObject.slug || ''}
            onChange={e => setFormObject({ ...formObject, slug: e.target.value })}
            onBlur={e => onBlurToSlug(e.target.value)}
            type="text"
            className="form-control"
            id="slug"
            placeholder="Slug"
          />
        </div>

        <div className="col-12">
          <label htmlFor="description">Descrição sobre o Momento</label>
          <textarea
            className="form-control"
            id="description"
            rows="6"
            style={{ width: '100%' }}
            value={formObject.description}
            onChange={e => setFormObject({ ...formObject, description: e.target.value })}
            placeholder="Descrição sobre o Momento"
          />
        </div>
      </div>
    </>
  )
}

export default MomentData
